import { NotificationType } from "./NotificationType";

export enum NotificationChannel {
    NONE = 'NONE',
    NOTICE = 'NOTICE',
    EMAIL = 'EMAIL'
}

export enum NotificationRecipientScope {
    BY_ROLE = 'BY_ROLE',
    ALL_MEMBERS = 'ALL_MEMBERS'
}

export enum NotificationRecipientLevel {
    PROJECT = 'PROJECT',
    ORGANIZATION = 'ORGANIZATION'
}

export interface NotificationTemplateItem {
  id?: string;
  eventType: NotificationType;
  description: string;
  priority: number;
  defaultChannels: (NotificationChannel | null)[];
  configurableChannels: (NotificationChannel | null)[];
  subjectTemplate: string;
  bodyTemplate: string;
  recipientScope: NotificationRecipientScope;
  targetRoles: string[];
  recipientLevel: NotificationRecipientLevel;
}
 